import React, { useEffect, useState } from 'react';
import InstantBanner from '../../util_components/instant_alert/InstantBanner';

// Ticks on its own so the form does not re-render every second.
function ErcInstantBanner(props) {
  const [now, set_now] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => set_now(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <InstantBanner {...props} now={now} label="INSTANT CHECKLIST" />;
}

export default ErcInstantBanner;
